import React from 'react';
import { GREEN } from '../const';

const SVG = ({ style = {}, color = GREEN, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <path d="M 40,30 L 66,50 40,70" fill={color} />
    </g>
  </svg>
);

export default SVG;
